const INTERACTIVE_SELECTOR =
  'button, a, input, label, select, textarea, [data-row-click-ignore]';

/**
 * Whether a click inside a table row must leave the row's own action alone:
 * it comes from a control (or a cell marked `data-row-click-ignore`), or it
 * ends a text selection, where opening the row would lose what was selected.
 */
const isRowClickIgnored = (event) => {
  if (event.target.closest?.(INTERACTIVE_SELECTOR)) return true;
  return Boolean(window.getSelection?.()?.toString());
};

export default isRowClickIgnored;
